import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import NotificationService from '../services/NotificationService'; // Import the Notification Service
import logo from '../logo.svg'; // Default fallback logo

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function Header() {
  const [logoUrl, setLogoUrl] = useState(logo); // Set default logo
  const [notifications, setNotifications] = useState([]); // State to store notifications
  const [unreadCount, setUnreadCount] = useState(0); // State to store unread notification count
  const navigate = useNavigate();

  // Check authentication
  const checkAuthentication = () => {
    const token = localStorage.getItem('token'); // Assuming token is stored in localStorage
    if (!token) {
      navigate('/logout');
    }
  };

  // Fetch logo from the API
  useEffect(() => {
    checkAuthentication(); // Verify authentication
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/settings`);
        const { logo: apiLogo } = response.data;
        setLogoUrl(apiLogo ? `${config.fileBaseUrl}${apiLogo}` : logo);
      } catch (error) {
        console.error('Error fetching logo:', error);
      }
    };
    fetchSettings();
  }, []);

  // Fetch notifications
  useEffect(() => {
    checkAuthentication(); // Verify authentication before fetching notifications
    const fetchNotifications = async () => {
      try {
        const allNotifications = await NotificationService.getAllNotifications();
        const unreadNotifications = await NotificationService.getUnreadNotifications();
        setNotifications(allNotifications);
        setUnreadCount(unreadNotifications.length);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };
    fetchNotifications();
  }, []);

  // Mark all notifications as read
  const markAllAsRead = async () => {
    try {
      await NotificationService.markAllAsRead();
      setUnreadCount(0); // Reset unread count
    } catch (error) {
      console.error('Error marking notifications as read:', error);
    }
  };

  return (
    <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      {/* Logo Section */}
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <a className="navbar-brand brand-logo mr-5" href="/">
          <img
            src={logoUrl}
            alt="logo"
            className="img-fluid"
            style={{ maxWidth: '150px', height: 'auto' }}
          />
        </a>
        <a className="navbar-brand brand-logo-mini" href="/">
          <img
            src={logoUrl}
            alt="mini logo"
            className="img-fluid"
            style={{ maxWidth: '50px', height: 'auto' }}
          />
        </a>
      </div>

      {/* Navigation Items */}
      <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
        {/* Notifications Dropdown */}
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item dropdown">
            <a
              className="nav-link count-indicator dropdown-toggle"
              href="#"
              id="notificationDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ti-bell mx-0"></i>
              {unreadCount > 0 && (
                <span className="count bg-danger">{unreadCount}</span>
              )}
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end navbar-dropdown"
              aria-labelledby="notificationDropdown"
            >
              <li className="dropdown-header d-flex justify-content-between">
                <span>Notifications</span>
                <button
                  className="btn btn-link p-0 text-primary"
                  onClick={markAllAsRead}
                >
                  Mark all as read
                </button>
              </li>
              {notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <li key={index} className="dropdown-item">
                    <div className="item-content">
                      <h6 className="font-weight-normal">{notification.title}</h6>
                      <p className="font-weight-light small-text mb-0 text-muted">
                        {notification.message}
                      </p>
                    </div>
                  </li>
                ))
              ) : (
                <li className="dropdown-item text-muted">No notifications</li>
              )}
            </ul>
          </li>

          {/* Profile Dropdown */}
          <li className="nav-item nav-profile dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="profileDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ891HLuugNKthcStMIQ3VD_phd6XrcYAhkjA&s"
                alt="profile"
                className="rounded-circle"
                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
              />
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end navbar-dropdown"
              aria-labelledby="profileDropdown"
            >
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => navigate('/settings')}
                >
                  <i className="ti-settings text-primary"></i> Settings
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => navigate('/logout')}
                >
                  <i className="ti-power-off text-primary"></i> Logout
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Header;
